<div appMaterialElevation class="content-header p-24" fxLayout="row wrap" fxLayoutAlign="start center">
    <button *ngIf="enableBack" mat-icon-button class="back-arrow" (click)="back()">
        <mat-icon>arrow_back</mat-icon>
    </button>
    <h1 class="text-white m-0 px-24">{{ headerText }}</h1>
</div>
